import { useEffect } from "react";
import * as S from "./Wallet.styled";
import { WalletBar } from "./WalletBar";
import { UserInvestmentsInfo } from "./UserInvestmentsInfo";
import { useCookie3 } from "../../../context/Cookie3Provider";

const Wallet = () => {
  const cookie3 = useCookie3();

  useEffect(() => {
    cookie3?.trackPageView({
      documentTitle: "Wallet",
    });
  }, []);
  return (
    <S.Container>
      <S.Wrapper>
        <WalletBar />
        <UserInvestmentsInfo />
      </S.Wrapper>
    </S.Container>
  );
};

export default Wallet;
